import { Portal } from 'react-portal';
import WebsiteFeedMain from './WebsiteFeedMain';
import { useContext, useState } from 'react';
import { store } from 'components/Store';
import WebsiteFeaturePopupContent from './WebsiteFeaturePopup';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import ModalComponent from 'components/Common/Modal';
import { dataHubUsers } from 'components/Dashboard/SidebarElements/parliamentarianUsers';
import { ContentResultsProvider } from 'components/Dashboard/ContentResultsContext';

const EmbedWebsiteButton = (props) => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { activePlan } = state;
  const { enableEmbedWidgets } = activePlan;

  const { listToUse } = props;
  const [showPopup, setShowPopup] = useState(false);
  const [showFeaturePopup, setShowFeaturePopup] = useState(false);

  const { newAgencyPlan } = useTopicOrClientWord();
  const dataHubUser = dataHubUsers(activePlan);
  return (
    <>
      <button
        className='action-button general-button px-4 py-2 rounded-pill'
        onClick={() => {
          if (dataHubUser) {
            dispatch({
              type: 'MODIFY_SECTION',
              parameter: 'dataHubNavigationPopup',
              value: { isOpen: true, allowClose: true },
            });
          } else if (enableEmbedWidgets) {
            setShowPopup(true);
          } else {
            setShowFeaturePopup(true);
          }
        }}
      >
        Embed a real-time feed{' '}
        <span className='d-none d-lg-inline-block'>on {newAgencyPlan ? 'any' : 'your'} website</span>
        {(!enableEmbedWidgets || dataHubUser) && <span className='icon-padlock ml-2 paragraph-p3' />}
      </button>
      <WebsitePopup setShowPopup={setShowPopup} showPopUp={showPopup} listToUse={listToUse} />
      <WebsiteFeaturePopup setShowPopup={setShowFeaturePopup} showPopUp={showFeaturePopup} />
    </>
  );
};

const WebsitePopup = (props) => {
  const { showPopUp, setShowPopup } = props;
  return (
    <Portal>
      <ModalComponent
        style={{ height: '94vh', minHeight: 'auto' }}
        maxWidth={1050}
        isOpen={showPopUp}
        setIsOpen={setShowPopup}
        stopInnerMouseDownPropagation={false}
      >
        <ContentResultsProvider>
          <WebsiteFeedMain {...props} />
        </ContentResultsProvider>
      </ModalComponent>
    </Portal>
  );
};

const WebsiteFeaturePopup = (props) => {
  const { showPopUp, setShowPopup } = props;
  return (
    <Portal>
      <ModalComponent maxWidth={900} isOpen={showPopUp} setIsOpen={setShowPopup}>
        <WebsiteFeaturePopupContent {...props} />
      </ModalComponent>
    </Portal>
  );
};

export { WebsitePopup, WebsiteFeaturePopup };
export default EmbedWebsiteButton;
